import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, useMediaQuery } from "@mui/material";
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import { MenuOrientation, DRAWER_WIDTH, HEADER_HEIGHT } from "config";
import useConfig from "hooks/useConfig";
import withRouter from "components/withRouter";
import regtechLogo from "assets/images/regtech-logo.png";
import Logo from "components/logo";

const DrawerHeader = (props) => {
  const { open, userData: initialUserData, theme, service } = props;
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const { menuOrientation } = useConfig();
  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const getLogoSrc = (data) => {
    if (data?.orgInfo?.companyLogo?.trim?.()?.length > 0) {
      return service?.IMG_URL + data?.orgInfo?.companyLogo;
    }
    return regtechLogo;
  }

  const [userData, setUserData] = useState(initialUserData);
  const [logoSrc, setLogoSrc] = useState(getLogoSrc(initialUserData));

  // Listen for company logo updates
  useEffect(() => {
    const handleCompanyLogoUpdate = (event) => {
      const { companyLogo } = event?.detail || {};
      const updatedUser = {
        ...userData,
        orgInfo: { ...userData?.orgInfo, companyLogo },
      };
      setUserData(updatedUser);
      setLogoSrc(getLogoSrc(updatedUser));
    };

    window.addEventListener("companyLogoUpdated", handleCompanyLogoUpdate);
    return () =>
      window.removeEventListener("companyLogoUpdated", handleCompanyLogoUpdate);
  }, [userData, service]);

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        minHeight: isHorizontal ? "unset" : HEADER_HEIGHT,
        width: isHorizontal
          ? { xs: "100%", lg: DRAWER_WIDTH + 50 }
          : "inherit",
        paddingTop: isHorizontal ? { xs: "10px", lg: "0" } : "8px",
        paddingBottom: isHorizontal ? { xs: "18px", lg: "0" } : "8px",
        paddingLeft: isHorizontal ? { xs: "24px", lg: "0" } : open ? "0px" : 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ margin: "auto" }}>
        <Logo
          images={logoSrc}
          isIcon={!open}
          sx={{
            height: "50px",
            padding: "0 5px",
            objectFit: "contain",
            objectPosition: "center",
            display: "block",
          }}
          onError={() => {
            if (logoSrc !== regtechLogo) {
              setLogoSrc(regtechLogo);
            }
          }}
        />
      </Box>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool,
  userData: PropTypes.object,
  theme: PropTypes.object,
  service: PropTypes.object,
};

export default withRouter(DrawerHeader);
